// 功能開放預告顯示彈窗
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Image from 'next/image';

import ComingNotify from './coming/ComingNotify'; // 開放通知
import ComingEmail from './coming/ComingEmail'; // 信箱登記
import ComingFollow from './coming/ComingFollow'; // 社群連結

const ComingSoonModal = ({ dispatch, setShowComingModal, showComingModal }) => {
    const { t } = useTranslation();
    // 步驟
    const [step, setStep] = useState(1);

    // 關閉彈窗
    const onClose = () => dispatch(setShowComingModal(false));

    return (
        <>
            <div className="modal">
                <div className="w-[492px] mx-auto relative !z-[2] !overflow-visible">
                    {/* 功能即將開放 */}
                    {step === 1 && (
                        <ComingNotify t={t} setStep={setStep} showComingModal={showComingModal} />
                    )}

                    {/* 信箱登記 */}
                    {step === 2 && (
                        <ComingEmail t={t} setStep={setStep} showComingModal={showComingModal} />
                    )}

                    {/* 社群連結 */}
                    {step === 3 && <ComingFollow t={t} onClose={onClose} />}
                </div>

                {/* 關閉用彈窗 */}
                <div className="close-bg" />

                {/* 背景 */}
                <div className="absolute set-center z-[1] space-y-[0px]">
                    <div className="img-box w-[492px] h-[458px]">
                        <Image
                            className="absolute"
                            width={492}
                            height={458}
                            src="/images/layout/adult_bg.webp"
                            alt="background"
                            sizes="350px"
                        />
                    </div>

                    {/* 關閉按鈕 */}
                    <button className="mx-auto block relative z-[1]" onClick={onClose}>
                        <Image
                            className="!object-contain"
                            width={34}
                            height={34}
                            sizes="30px"
                            src="/images/icon/icon_close_modal.svg"
                            alt="icon"
                        />
                    </button>
                </div>
            </div>
        </>
    );
};

export default ComingSoonModal;
